import React from "react";
import { Table, Tag, Button, Empty } from "antd";
import { EyeOutlined, PlayCircleOutlined } from "@ant-design/icons";

const statusColors = {
    success: "green",
    failed: "red",
    pending: "gold",
    running: "blue",
    never_executed: "default",
};

export default function ViewsQuadrant({
    views = [],
    selectedViewId,
    onSelectView,
    onViewDetail,
    onRunView,
    permission,
}) {
    const columns = [
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            width: 80,
            render: (status) => (
                <Tag color={statusColors[status] || "default"} className="text-xs">
                    {status === "success" ? "✓" : status === "failed" ? "✕" : "○"}
                </Tag>
            ),
        },
        {
            title: "View Name",
            dataIndex: "viewName",
            key: "viewName",
            ellipsis: true,
            render: (text, record) => (
                <a onClick={() => onViewDetail && onViewDetail(record.viewId)} className="text-xs">
                    {text}
                </a>
            ),
        },
        {
            title: "Source Dataset",
            dataIndex: "sourceDatasetId",
            key: "sourceDatasetId",
            ellipsis: true,
            width: 120,
        },
        {
            title: "Steps",
            key: "steps",
            width: 60,
            align: "center",
            render: (_, record) => {
                const count = record.pipelineStepsSnapshot ? record.pipelineStepsSnapshot.length : 0;
                return <span className="text-xs">{count}</span>;
            },
        },
        {
            title: "Records",
            dataIndex: "recordCount",
            key: "recordCount",
            width: 80,
            align: "center",
            render: (count) => <span className="text-xs">{(count || 0).toLocaleString()}</span>,
        },
        {
            title: "Last Executed",
            dataIndex: "lastExecuted",
            key: "lastExecuted",
            width: 130,
            render: (date) => <span className="text-xs">{date ? new Date(date).toLocaleString() : "Never"}</span>,
        },
        {
            title: "",
            key: "actions",
            width: 70,
            render: (_, record) => (
                <div className="flex items-center gap-1">
                    <Button
                        type="text"
                        size="small"
                        icon={<EyeOutlined />}
                        onClick={() => onViewDetail && onViewDetail(record.viewId)}
                    />
                    {permission?.canEdit && (
                        <Button
                            type="text"
                            size="small"
                            icon={<PlayCircleOutlined />}
                            onClick={() => onRunView && onRunView(record.viewId)}
                        />
                    )}
                </div>
            ),
        },
    ];

    return (
        <div className="flex flex-col h-full">
            <Table
                columns={columns}
                dataSource={views}
                rowKey="viewId"
                size="small"
                pagination={false}
                scroll={{ y: 300 }}
                onRow={(record) => ({
                    onClick: () => onSelectView && onSelectView(record.viewId),
                    style: {
                        backgroundColor: record.viewId === selectedViewId ? "#e5f3ff" : undefined,
                        cursor: "pointer",
                    },
                })}
                locale={{
                    emptyText: (
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description="No views yet"
                        />
                    ),
                }}
            />
        </div>
    );
}
